import * as React from 'react';
import { Text, Heading } from 'wix-style-react';
import { useTranslation } from 'react-i18next';
import s from './SideTitle.scss';

interface SideTitleProps {
  titleKey: string;
  subtitleKey?: string;
}

export const SideTitle: React.FC<SideTitleProps> = ({
  titleKey,
  subtitleKey,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s.sideTitleContainer}>
      <Heading className={s.sideTitleHeading} appearance='H2'>
        {t(titleKey)}
      </Heading>
      {subtitleKey && <Text className={s.sideSubtitle}>{t(subtitleKey)}</Text>}
      {children}
    </div>
  );
};
